/**
 *  Module for model and alternate views display
 */

const Model = function (app) {

  /**
   *  Private Properties/Methods
   */
  const _ = require('lodash');
  const configure = app.configure;

  function toggleDisplayLoading(options = {}) {
    const $model = app.$container.find('.fc-model-container-wrapper');
    const loadingClass = 'fc-monogramming-display-loading';

    if (options.forceRemove) {
      $model.removeClass(loadingClass);
    } else {
      $model.toggleClass(loadingClass);
    }
  }

  function checkMonogramUGC(arg) {
    const monogramUGC = app.store.monogramUGC();
    const view = app.store.currentView();

    if (
      (
        arg.img &&
        arg.img.src.indexOf(monogramUGC) !== -1 &&
        arg.img.src.indexOf(view) !== -1
      ) ||
      arg.img.src.indexOf('&e1') !== -1
    ) {
      app.monogram.toggleDisplayLoading({ forceRemove: true });
      // we upload non value so this won't get triggered accidentally.
      app.actions.updateMonogramUGC(encodeURIComponent('none'));
      // Update the cart status to disable/enable.
      app.cart.updateAddToCart();
    }
  }

  function validateDtgImage(arg) {
    const view = app.store.currentView();
    const ugcUrl = app.mergedParams.dtgUrls[view];

    if (arg.img && arg.img.src === ugcUrl) {
      app.mergedParams.dtgDisableCart = false;
      app.cart.updateAddToCart();
    }
  }

  const initialModelRender = _.once(() => {
    app.performance.record('Init', 'Configure Init to Model Render', ['configure:init', 'configure:model:rendered']);
  });

  function init() {
    const options = {
      type: 'displayCarousel',
      container: '.fc-model-container',
      backgroundColor: app.backgroundColor,
      viewNames: app.views,
      dots: false,
      arrows: true,
      touchMove: false,
      preview: false,
      selectedView: 'front',
      format: 'jpg',
      quality: 91
    };

    if (app.product.id === 22949) {
      // The Lead like a woman product has an aditional view that we need to use as default..
      options.selectedView = 'on_model';
    }

    if (app.utils.isMobile() || app.utils.isVerticalTablet()) {
      options.dots = true;
      options.touchMove = true;
      options.arrows = false;
    }

    configure.run('createComponent', options, function (err, model) {
      if (err) { throw err; }

      let progress = 10;
      const timer = setInterval(function () {
        if (progress <= 90) {
          progress += 5;
          app.appUtils.setProgress(progress);
        }
      }, 200);
      app.actions.updateView(options.viewNames[0]);

      model.on('image:loaded', function (arg) {
        const view = app.helpers.getUrlParam('view', arg.img.currentSrc);
        const currentView = app.store.currentView();

        checkMonogramUGC(arg);
        if (app.appUtils.isDTGProduct()) {
          validateDtgImage(arg);
        }
        clearInterval(timer);
        app.appUtils.setProgress(100);
        app.actions.imageLoaded();

        if (view === currentView) {
          app.performance.mark(`configure:model:rendered`);

          if (app.performance.textRender()) {
            app.performance.ugcSteps();
          }

          initialModelRender();
        }
      });

      model.on('display:viewChange', function (viewName) {
        if (app.store.currentView() !== viewName) {
          app.actions.updateView(viewName);
        }
      });

      app.store.subscribe(function () {
        if (app.store.refreshUI()) {
          model.trigger('display:selectedView', app.store.currentView());
        }
      });

    });
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    toggleDisplayLoading
  };
};

module.exports = Model;
